<template>
    <div id="income-and-expenses">
        <step-title class="income-and-expenses-title" step-title="Income and Expenses"></step-title>
        <two-text-fields-with-symbols-version2 class="calc-input rental-income" :value-one="rentalIncomeAmountValue" :value-two="rentalIncomePercentageValue" v-on:calcOne="calcRentalIncomeAmountValue" v-on:calcTwo="calcRentalIncomePercentageValue" label="Weekly Rental Income" is-bold-font placeholder-one="" placeholder-two="" symbol-one="$" symbol-two="%" has-tooltip></two-text-fields-with-symbols-version2>
        <div class="calc-extra-info" style="width: 85%; margin: 0 auto; margin-bottom: 125px; margin-top: -15px"> <p class="extra-info-annual" style="float: right; width: 170px; margin-left: 70%; margin-top: -15px; padding-right: 3px; color: #465978; font-size: 15px; text-align: right">Annual ${{ rentalIncomeAnnualValue }}</p></div>
        <div class="weekly-rental-income-require-info-container" style="width: 85%; margin-left: auto; margin-right: auto">
            <span v-show="!this.$store.state.weeklyRentalIncomeEntered" class="text-danger" style="float: right; height: 0; font-size: 13px; margin-top: -25px;">Input Required</span>
        </div>
        <div class="calc-col-one">
            <sub-step-title class="annual-expenses-header" sub-step-title="Annual Expenses" v-bind:has-tooltip="false"></sub-step-title>
            <text-field-with-symbol class="council-rates" :value="councilRatesValue" v-on:calc="calcCouncilRatesValue" name="Council-Rates" label="Council Rates" v-bind:is-bold-font="false" placeholder="" symbol="$" has-tooltip></text-field-with-symbol>
            <text-field-with-symbol class="insurance" :value="buildingInsuranceOrStrataFeesValue" v-on:calc="calcBuildingInsuranceOrStrataFeesValue" name="Insurance-or-Strata-Fees" label="Insurance or Strata Fees" v-bind:is-bold-font="false" placeholder="" symbol="$" has-tooltip></text-field-with-symbol>
            <text-field-with-symbol class="other-expenses" :value="otherExpensesValue" v-on:calc="calcOtherExpensesValue" name="Other-Expenses" label="Other Expenses" v-bind:is-bold-font="false" placeholder="" symbol="$" has-tooltip></text-field-with-symbol>
            <text-field-with-extra-label class="vacancy-period" :value="vacancyPeriodValue" v-on:calc="calcVacancyPeriodValue" name="Vacancy-Period" label="Vacancy Period" v-bind:is-bold-font="false" placeholder="" extra-label="Weeks" has-tooltip></text-field-with-extra-label>
            <text-field-with-percentage class="property-management-textfield" :value="propertyManagementValue" v-on:calc="calcPropertyManagementValue" name="Management-Fee" label="Management Fee" v-bind:is-bold-font="false" placeholder="" symbol="%" has-tooltip></text-field-with-percentage>
            <sub-step-result-label class="total-expenses" result-label="Total Expenses" :step-result="totalAnnualExpensesValue"></sub-step-result-label>
        </div>
        <div class="calc-col-two">
            <sub-step-title class="interest-on-loan-header" sub-step-title="Interest on Loan" v-bind:has-tooltip="false"></sub-step-title>
            <text-field-with-symbol class="loan-amount" :value="loanAmountValue" v-on:calc="calcLoanAmountValue" name="Loan-Amount" label="Loan Amount" v-bind:is-bold-font="false" placeholder="" symbol="$" has-tooltip></text-field-with-symbol>
            <div id="lvr" style="width: 85%; margin: 0 auto; margin-bottom: 50px; margin-top: -15px"> <p class="extra-info-lvr" style="float: right; width: 50%; margin-left: auto; margin-bottom: 0; padding-right: 3px; color: #465978; font-size: 15px; text-align: right;">Loan to Value Ratio (LVR): {{ loanToValueRatioValue }}%</p></div>
            <text-field-with-symbol class="lenders-mortgage-insurance" :value="lendersMortgageInsuranceValue" v-on:calc="calcLendersMortgageInsuranceValue" name="Lenders-Mortgage-Insurance" label="Lender's Mortgage Insurance (LMI)" v-bind:is-bold-font="false" placeholder="" symbol="$" has-tooltip></text-field-with-symbol>
            <div class="lmi-error-info-container" style="width: 85%; margin-left: auto; margin-right: auto">
                <span v-show="lendersMortgageInsuranceErrorText !== ''" id="lmi-error" class="text-danger" style="float: right; height: 0; font-size: 13px; margin-top: -20px; width: 50%; text-align: right; clear: right;">{{ lendersMortgageInsuranceErrorText }}</span>
            </div>
            <button-group-two class="loan-type-button-group" :current-value="loanTypeValue" v-on:calcOne="calcLoanTypeValue" v-on:calcTwo="calcLoanTypeValue" name="Loan-Type" label="Loan Type" button-one-text="Principal & Interest" button-two-text="Interest Only" has-tooltip></button-group-two>
            <text-field-with-extra-label class="loan-term" :value="loanTermValue" v-on:calc="calcLoanTermValue" name="Loan-Term" label="Loan Term" v-bind:is-bold-font="false" placeholder="" extra-label="Years" has-tooltip></text-field-with-extra-label>
            <text-field-with-percentage class="interest-rate" :value="interestRateValue" v-on:calc="calcInterestRateValue" name="Interest-Rate" label="Interest Rate" v-bind:is-bold-font="false" placeholder="" symbol="%" has-tooltip></text-field-with-percentage>
            <div style="width: 85%; margin-left: auto; margin-right: auto">
                <span v-show="!this.$store.state.interestRateEntered" class="text-danger" style="float: right; height: 0; font-size: 13px; margin-top: -18px;">Input Required</span>
            </div>
            <sub-step-result-label class="calc-results interest-result sub-result" result-label="Interest Repayment" :step-result="annualInterestRepaymentsValue"></sub-step-result-label>
            <sub-step-result-label class="calc-results interest-result sub-result" result-label="Principal Repayment" :step-result="annualPrincipalRepaymentsValue"></sub-step-result-label>
            <sub-step-result-label class="calc-results interest-result interest-on-equity-funds sub-result" result-label="Interest on Equity Funds" :step-result="annualInterestOnEquityFundsValue"></sub-step-result-label>
        </div>
        <step-result-label result-label="TOTAL EXPENSES + INTEREST" :step-result="totalExpensesValue"></step-result-label>
    </div>
</template>

<script>
    import StepTitle from './StepTitle';
    import SubStepTitle from './SubStepTitle';
    import TextFieldWithSymbol from './TextFieldWithSymbol';
    import ButtonGroupTwo from './ButtonGroupTwo';
    import TwoTextFieldsWithSymbolsVersion2 from './TwoTextFieldsWithSymbolsVersion2';
    import TextField from './TextField';
    import TextFieldWithPercentage from './TextFieldWithPercentage';
    import TextFieldWithExtraLabel from './TextFieldWithExtraLabel';
    import SubStepResultLabel from './SubStepResultLabel';
    import StepResultLabel from './StepResultLabel';

    export default {
        components: {
            StepTitle,
            SubStepTitle,
            TextFieldWithSymbol,
            ButtonGroupTwo,
            TwoTextFieldsWithSymbolsVersion2,
            TextField,
            TextFieldWithPercentage,
            TextFieldWithExtraLabel,
            SubStepResultLabel,
            StepResultLabel
        },
        name: "income-and-expenses",
        computed: {
            rentalIncomeAmountValue() {
                return this.$store.state.incomeAndExpenses.getRentalIncomeAmount();
            },
            rentalIncomePercentageValue() {
                return this.$store.state.incomeAndExpenses.getRentalIncomePercentage();
            },
            rentalIncomeAnnualValue() {
                return this.$store.state.incomeAndExpenses.getRentalIncomeAnnual().toLocaleString('en-US',{useGrouping:true});
            },
            councilRatesValue() {
                return this.$store.state.incomeAndExpenses.getCouncilRates();
            },
            buildingInsuranceOrStrataFeesValue() {
                return this.$store.state.incomeAndExpenses.getBuildingInsuranceOrStrataFees();
            },
            otherExpensesValue() {
                return this.$store.state.incomeAndExpenses.getOtherExpenses();
            },
            propertyManagementValue() {
                return this.$store.state.incomeAndExpenses.getPropertyManagement();
            },
            vacancyPeriodValue() {
                return this.$store.state.incomeAndExpenses.getVacancyPeriod();
            },
            totalAnnualExpensesValue() {
                return this.$store.state.incomeAndExpenses.getTotal();
            },
            loanAmountValue() {
                return this.$store.state.incomeAndExpenses.getLoanAmount();
            },
            loanToValueRatioValue() {
                return this.$store.state.incomeAndExpenses.getLoanToValueRatio();
            },
            loanTypeValue() {
                return this.$store.state.incomeAndExpenses.getLoanType();
            },
            loanTermValue() {
                return this.$store.state.incomeAndExpenses.getLoanTerm();
            },
            lendersMortgageInsuranceValue() {
                return this.$store.state.incomeAndExpenses.getLendersMortgageInsurance();
            },
            interestRateValue() {
                return this.$store.state.incomeAndExpenses.getInterestRate();
            },
            annualInterestRepaymentsValue() {
                return this.$store.state.incomeAndExpenses.getAnnualInterestRepayments();
            },
            annualPrincipalRepaymentsValue() {
                return this.$store.state.incomeAndExpenses.getAnnualPrincipalRepayments();
            },
            annualInterestOnEquityFundsValue() {
                return this.$store.state.incomeAndExpenses.getAnnualInterestOnEquityFunds();
            },
            totalExpensesValue() {
                return this.$store.state.incomeAndExpenses.getTotalExpenses().toLocaleString('en-US',{useGrouping:true});
            },
            lendersMortgageInsuranceError() {
                return this.lendersMortgageInsuranceValue === "LVR above 95%!" ||
                    this.lendersMortgageInsuranceValue === "Loan Amount above 1000000!";
            },
            lendersMortgageInsuranceErrorText() {
                if (this.$store.state.incomeAndExpenses.getLoanToValueRatio() > 95.00 && this.$store.state.incomeAndExpenses.getLendersMortgageInsurance() === 0) {
                    return "LVR above 95%!";
                } else if (this.$store.state.incomeAndExpenses.getLoanAmount() > 1000000 && this.$store.state.incomeAndExpenses.getLendersMortgageInsurance() === 0) {
                    return "Loan Amount above $1M!";
                } else {
                    return '';
                }
            }
        },
        methods: {
            calcRentalIncomeAmountValue: function(rentalIncomeAmount) {
                this.$store.commit('rentalIncomeAmountValueCalc', rentalIncomeAmount);
            },
            calcRentalIncomePercentageValue: function(rentalIncomePercentage) {
                this.$store.commit('rentalIncomePercentageValueCalc', rentalIncomePercentage);
            },
            calcRentalIncomeAnnualValue: function(rentalIncomeAnnual) {
                this.$store.commit('rentalIncomeAnnualValueCalc', rentalIncomeAnnual);
            },
            calcCouncilRatesValue: function(councilRates) {
                this.$store.commit('councilRatesValueCalc', councilRates);
            },
            calcBuildingInsuranceOrStrataFeesValue: function(buildingInsuranceOrStrataFees) {
                this.$store.commit('buildingInsuranceOrStrataFeesValueCalc', buildingInsuranceOrStrataFees);
            },
            calcOtherExpensesValue: function(otherExpenses) {
                this.$store.commit('otherExpensesValueCalc', otherExpenses);
            },
            calcPropertyManagementValue: function(propertyManagement) {
                this.$store.commit('propertyManagementValueCalc', propertyManagement);
            },
            calcVacancyPeriodValue: function(vacancyPeriod) {
                this.$store.commit('vacancyPeriodValueCalc', vacancyPeriod);
            },
            calcTotalAnnualExpensesValue: function(totalAnnualExpenses) {
                this.$store.commit('totalAnnualExpensesCalc', totalAnnualExpenses);
            },
            calcLoanAmountValue: function(loanAmount) {
                this.$store.commit('loanAmountValueCalc', loanAmount);
            },
            calcLoanToValueRatioValue: function(loanToValueRatio) {
                this.$store.commit('loanToValueRatioValueCalc', loanToValueRatio);
            },
            calcLoanTypeValue: function(loanType) {
                this.$store.commit('loanTypeValueCalc', loanType);
            },
            calcLoanTermValue: function(loanTerm) {
                this.$store.commit('loanTermValueCalc', loanTerm);
            },
            calcLendersMortgageInsuranceValue: function(lendersMortgageInsurance) {
                this.$store.commit('lendersMortgageInsuranceValueCalc', lendersMortgageInsurance);
            },
            calcInterestRateValue: function(interestRate) {
                this.$store.commit('interestRateValueCalc', interestRate);
            },
            calcAnnualInterestRepaymentsValue: function(annualInterestRepayments) {
                this.$store.commit('annualInterestRepaymentsValueCalc', annualInterestRepayments);
            },
            calcAnnualPrincipalRepaymentsValue: function(annualPrincipalRepayments) {
                this.$store.commit('annualPrincipalRepaymentsValueCalc', annualPrincipalRepayments);
            },
            calcAnnualInterestOnEquityFundsValue: function(annualInterestOnEquityFunds) {
                this.$store.commit('annualInterestOnEquityFundsValueCalc', annualInterestOnEquityFunds);
            },
            calcTotalExpensesValue: function(totalExpenses) {
                this.$store.commit('totalExpensesValueCalc', totalExpenses);
            }
        }
    }
</script>

<style scoped>

    #income-and-expenses {
        overflow: auto;
    }

    .loan-type-button-group {
        overflow: visible;
    }

    .extra-bottom-margin {
        margin-bottom: 30px !important;
    }

    .rental-income {
        margin-top: 30px !important;
    }

    .interest-on-equity-funds {
        margin-bottom: 20px !important;
    }

    .total-result {
        width: 95%;
        margin: 0 auto;
        padding-left: 5%;
        padding-right: 5%;
        margin-bottom: 15px;
        clear: both;
        text-align: right !important;
        background: rgb(237, 239, 241);
        font-family: 'Roboto', Arial, serif;
        font-weight: bold;
        color: #465978;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .total-result-label {
        width: 52%;
        float: left;
        text-align: left;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 0;
    }

    .total-result-value {
        font-size: 20px;
        margin-left: auto;
        direction: rtl;
        word-wrap: break-word;
        font-weight: bold;
        margin-bottom: 0;
    }

    .annual-expenses-header {
        margin-bottom: 30px;
    }

    .interest-result, .total-expenses {
        background-color: inherit !important;
    }

    .interest-on-loan-header {
        margin-bottom: 30px;
    }

    .lenders-mortgage-insurance {
        display: block !important;
    }

    @media (max-width: 1024px) {
        .interest-on-loan-header {
            margin-top: 30px;
        }
    }

    @media not print {
        @media (min-width: 1023px) {
            .interest-on-loan-header {
                margin-top: 0;
            }

            .property-management-textfield {
                margin-bottom: 15px !important;
            }

            .interest-rate {
                margin-bottom: 0 !important;
            }
        }
    }

    ul.leaders {
        max-width: 40em;
        padding: 0;
        overflow-x: hidden;
        list-style: none;
    }

    .total-result-desktop {
        width: 100%;
        display: flex;
    }

    @media not print {
        @media (min-width: 1024px) {

            .calc-input {
                width: 45% !important;
                min-width: 320px !important;
            }

            .calc-extra-info {
                width: 45% !important;
                min-width: 320px !important;
            }

            .calc-col-one {
                width: 49%;
                float: left;
            }

            .calc-col-two {
                width: 49%;
                float: right;
            }

            .calc-results {
                font-size: 20px !important;
            }

            .total-result {
                display: flex;
                width: 100%;
                padding-right: 4%;
                padding-left: 4%;
                margin-left: 0;
                margin-right: 0;
                margin-bottom: 30px;
            }

            .total-result-label {
                width: 52%;
                align-self: flex-end;
            }

            .total-result-value {
                align-self: flex-end;
            }

            .total-result-desktop {
                width: 49%;
                float: right;
            }

            .interest-result, .total-expenses {
                width: 95% !important;
                margin-left: auto !important;
                margin-right: auto !important;
                padding-left: 5% !important;
                padding-right: 5% !important;
            }

            .property-management-textfield {
                margin-bottom: 0 !important;
            }

            .weekly-rental-income-require-info-container {
                width: 45% !important;
                min-width: 320px !important;
            }
        }
    }

    @media (max-width: 1023px) {

        #lvr {
            margin-bottom: 40px !important;
        }

        .extra-info {
            font-size: 15px !important;
        }

        .extra-bottom-margin-width-max-767 {
            margin-bottom: 35px !important;
        }
    }

    @media (max-width: 694px) {
        .total-result {
            display: flex;
        }

        .total-result-label {
            width: 52%;
            align-self: flex-end;
        }

        .total-result-value {
            align-self: flex-end;
        }
    }

    @media (max-width: 550px) {
        #lvr {
            margin-bottom: 55px !important;
        }
    }
    
    @media (max-width: 344px) {
        .calc-extra-info {
            margin-bottom: 155px !important;
        }
    }

    @media print {
        .calc-col-one {
            page-break-after: always;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/IncomeAndExpenses.vue